import moment from 'moment';
import React from 'react';

const DocumentListItem = (props) => {
  const { document, onFetchSubDocuments, onCheckDocument, innerRef } = props;
  const documentName = `${document.origin}${
    document.documentNameCount > 0 ? `(${document.documentNameCount})` : ``
  }`;
  let user = document.user;

  return (
    <React.Fragment>
      <tr className="bb" ref={innerRef}>
        <td data-label="Name" className="document-name" style={{ width: '300px' }}>
          <div className="columnItemContainer">
            <div className="file-name-column">
              {document.type === 'document' && (
                <label className="custom-checkbox float-left mr10">
                  <span>
                    <input
                      type="checkbox"
                      checked={document.isChecked ? 1 : 0}
                      onClick={() => onCheckDocument(document)}
                    />
                    <span className="checkmark"></span>
                  </span>
                </label>
              )}
              {document.type === 'folder' && (
                <span className="folder-icon">
                  <i className="material-icons" style={{ fontSize: 22 }}>
                    arrow_right
                  </i>
                </span>
              )}
              <a onClick={() => onFetchSubDocuments(document)}>
                {document.type === 'folder' && <span className="fa fa-folder fa-lg read mr10" />}
                {document.type === 'folder' && <span className="read">{documentName}</span>}
                {document.type === 'document' && (
                  <React.Fragment>
                    <i className="material-icons mr5 text-size22 text-black">description</i>
                    <span className="read">{documentName}</span>
                  </React.Fragment>
                )}
              </a>
            </div>
          </div>
        </td>
        {/* uploaded by */}
        <td data-label="Uploaded by" className="document-name" style={{ width: '200px' }}>
          <div className="columnItemContainer">
            {document.type === 'folder' && <span className=""> -- </span>}
            {document.type === 'document' && (
              <span>
                {user.firstName} {user.lastName}
              </span>
            )}
          </div>
        </td>
        {/* uploaded data */}
        <td data-label="Upload Date" className="document-name" style={{ width: '200px' }}>
          <div className="columnItemContainer">
            {document.type === 'folder' && <span className=""> -- </span>}
            {document.type === 'document' && (
              <span>
                {document.dateAdded ? moment(document.dateAdded).format('MM/DD/YYYY') : ''}
              </span>
            )}
          </div>
        </td>
      </tr>
    </React.Fragment>
  );
};

// export default React.forwardRef((props, ref) => <DocumentListItem
//   innerRef={ref} {...props}
// />);

export default DocumentListItem;
